// extracted by mini-css-extract-plugin
export default {"whiteWrapper":"Alarms_whiteWrapper__V9Gi+","alarmsWrapper":"Alarms_alarmsWrapper__2S8rf","headerContainer":"Alarms_headerContainer__bm9lN"};